import clsx from 'clsx';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CAN_UNDO_COMMAND, CAN_REDO_COMMAND, UNDO_COMMAND, REDO_COMMAND } from 'lexical';
import { useEffect, useState } from 'react';

import { Icon } from 'components';
import styles from 'components/RteEditor/RteEditor.module.css';
import { useTranslation } from 'components/RteEditor/hooks/useTranslation';

export const HistoryPlugin = () => {
  const t = useTranslation();
  const [editor] = useLexicalComposerContext();
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  const handleUndo = () => {
    editor.dispatchCommand(UNDO_COMMAND, undefined);
  };

  const handleRedo = () => {
    editor.dispatchCommand(REDO_COMMAND, undefined);
  };

  useEffect(() => {
    return editor.registerCommand<boolean>(
      CAN_UNDO_COMMAND,
      (payload) => {
        setCanUndo(payload);
        return false;
      },
      1
    );
  }, [editor]);

  useEffect(() => {
    return editor.registerCommand<boolean>(
      CAN_REDO_COMMAND,
      (payload) => {
        setCanRedo(payload);
        return false;
      },
      1
    );
  }, [editor]);

  return (
    <div className={styles['editor__toolbar-button-group']}>
      <button
        onClick={handleUndo}
        className={clsx(styles['editor__toolbar-button'], styles[`editor__toolbar-button--undo`])}
        aria-label={t.aria.labels.undo}
        aria-keyshortcuts={t.aria.keyshortcuts.undo}
        disabled={!canUndo}
        title={t.format.undoTooltip}
        type="button"
      >
        <Icon name="StepBack" size={24} />
      </button>
      <button
        onClick={handleRedo}
        className={clsx(styles['editor__toolbar-button'], styles[`editor__toolbar-button--redo`])}
        aria-label={t.aria.labels.redo}
        aria-keyshortcuts={t.aria.keyshortcuts.redo}
        disabled={!canRedo}
        title={t.format.redoTooltip}
        type="button"
      >
        <Icon name="StepForwards" size={24} />
      </button>
    </div>
  );
};
